import { provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ProdConfig } from './blocks/config/prod.config';
import { FinitoAppModule } from './app.module';

ProdConfig();

if (module['hot']) {
  module['hot'].accept();
}

platformBrowserDynamic()
  .bootstrapModule(FinitoAppModule, { applicationProviders: [provideZoneChangeDetection()], preserveWhitespaces: true })
  .then(success => console.log('Application started'))
  .catch(err => console.error(err));
